import angular from 'angular';

angular.module('cxRelations').directive('cxRelWizard', [
  function() {
    return {
      restrict: 'E',
      template: require('./relWizard.html'),
      controllerAs: 'vm',
      scope: {
        userOptions: '=options',
        success: '&',
      },
      bindToController: true,
      controller: [
        '$state',
        '$filter',
        'relPersistSvc',
        'optionsSvc',
        'flySvc',
        'dialogsSvc',
        'externalRelationHttpSvc',
        'objectFactorySvc',
        'enumCacheSvc',
        '$q',
        '$element',
        '$timeout',
        'checkFeature',
        'appSettings',
        'dataCache',
        '$translate',
        'environment',
        '$http',
        'appUrls',
        function(
          $state,
          $filter,
          relPersistSvc,
          optionsSvc,
          flySvc,
          dialogsSvc,
          externalRelationHttpSvc,
          objectFactorySvc,
          enumCacheSvc,
          $q,
          $element,
          $timeout,
          checkFeature,
          appSettings,
          dataCache,
          $translate,
          environment,
          $http,
          appUrls,
        ) {
          var vm = this;
          vm.relTypes = [];
          vm.crmTypes = [];
          vm.teams = [];
          vm.isLoading = false;
          vm.showValidation = false;
          vm.options = {};

          vm.searchProvider = undefined;

          vm.hasTeams = false;

          vm.$onInit = function() {
            $http.get(`${appUrls.api}/api/Team/MyTeams`).then(({ data }) => {
              vm.options.hasTeams = (data || []).length > 0;
            });

            $http.get(`${appUrls.api}/api/Resource/Tags`).then(({ data }) => {
              vm.options.tags = data;
              vm.options.tagsDisabled = !checkSecurity('Tags:c');
            });

            enumCacheSvc.get('relationType').then(function(data) {
              vm.relTypes = data;
            });

            enumCacheSvc.get('crmType').then(function(data) {
              vm.crmTypes = data;
            });

            dataCache.ready().then(function() {
              let availableCompanies = dataCache
                .getArray('company')
                .map(x => ({ id: x.id, name: x.name }));

              availableCompanies = $filter('orderBy')(availableCompanies, 'name');

              let defaultCompany =
                dataCache.getDefaultCompanyForUser() ||
                availableCompanies[0] ||
                appSettings.defaultCompany;

              vm.options = angular.extend(
                {
                  relType: null,
                  crmType: null,
                  country: appSettings.defaultCountry,
                  company: defaultCompany,
                  relTypeDisabled: false,
                  crmTypeDisabled: false,
                  countryDisabled: false,
                  companyDisabled: false,
                  teams: [],
                  tags: [],
                  allowedRelTypes: [0, 1, 2],
                  showEID: true,
                },
                vm.userOptions || {},
              );

              vm.companies = availableCompanies;
              vm.options.showEID = vm.options.showEID && checkFeature('Eid');
              vm.relType = vm.options.relType;
              vm.crmType = vm.options.crmType;
              vm.country = vm.options.country;
              vm.company = vm.options.company;
              vm.teams = vm.options.teams;
              vm.tags = vm.options.tags;
              if (vm.options.companyId) {
                vm.company =
                  availableCompanies.find(x => x.id === vm.options.companyId) || vm.company;
              }

              vm.options.searchProviders = dataCache.getArray('relationSearchProviders');
              vm.options.searchProvidersFormatted = $filter('joinBy')(
                vm.options.searchProviders.map(x => {
                  return $filter('translateList')(x, 'ExternalRelationSearchProvider', x);
                }),
                ', ',
              );

              if (vm.options.searchProviders && vm.options.searchProviders.length > 0) {
                vm.searchProvider = vm.options.searchProviders[0];
                setSearchCriteriaString();
              }
              if (vm.relType !== null && vm.crmType !== null && vm.country) vm.create();
            });
          };

          vm.formReady = false;
          var showError = function(error) {
            vm.searching = false;
            console.log(error);
            flySvc.error(error);
          };

          vm.create = function() {
            vm.fields = [
              {
                definition: {
                  id: 'b5a73c11-4b57-436c-9236-2424594e16fe',
                },
                value: vm.teams,
              },
              {
                definition: {
                  id: '6153cbcf-5347-4f8a-8a1d-dcea1cee2df6',
                },
                value: vm.tags,
              },
            ];
            vm.formReady = false;
            if (vm.relType !== null && vm.crmType !== null && vm.country) {
              relPersistSvc
                .getWizardFields(vm.relType, vm.crmType, vm.country)
                .then(function(response) {
                  // todo remove this and replace by initFieldsSvc
                  for (var t = 0; t < response.length; t++) {
                    var definition = response[t];

                    //Set sort order
                    definition.order = definition.column * 3 + definition.position;
                    var value = null;
                    // Initialize the values of the fields coming in...
                    //console.log(definition.type);
                    switch (definition.type) {
                      case 3: {
                        if (definition.id === 'a54bd3dc-c415-48f3-afd4-ca2c5b457121')
                          value = new Date();
                        break;
                      }
                      case 10: {
                        value = optionsSvc.getDefault('currency')[0];
                        break;
                      }
                      case 12:
                        value = [
                          objectFactorySvc.address(1, vm.country),
                          objectFactorySvc.address(2, vm.country),
                          objectFactorySvc.address(4, vm.country),
                          objectFactorySvc.address(0, vm.country),
                        ];
                        break;
                      case 13:
                      case 14: {
                        value = [];
                        break;
                      }
                      case 15: {
                        value = $translate.use().split('-')[0]; //Use interface language
                        break;
                      }
                      case 19: {
                        if (definition.id === '04c56e09-eeff-4982-a243-0688b6f45a74')
                          value = vm.country;
                        break;
                      }
                      case 20: {
                        value = vm.relType;
                        break;
                      }
                      case 21: {
                        value = vm.crmType;
                        break;
                      }
                      case 82:
                        value = vm.company.id;
                        break;
                      case 40:
                        value = vm.tags;
                        break;

                      case 67: // teams
                        value = vm.teams;
                        break;
                      default:
                        break;
                    }
                    var field = {
                      definition: definition,
                      value: value,
                      inValid: false,
                    };
                    vm.fields.push(field);
                    //   vm.collapsed = 1;
                  }
                  console.log(vm.fields);
                  vm.formReady = true;
                  vm.focusFirstField();
                }, showError);
            }
          };

          var setSearchCriteriaString = () => {
            // display on which fields a relation can be found
            switch (vm.searchProvider) {
              case 0: // kbo
                vm.options.searchCriteriaString = $translate.instant('Name or enterprise number');
                break;
              case 1: // kvk
                vm.options.searchCriteriaString = $translate.instant('Name or KvK number');
                break;
              case 2: //estox
                vm.options.searchCriteriaString = $translate.instant('Enterprise number');
                break;
              default:
                vm.options.searchCriteriaString = $translate.instant('Name or enterprise number');
                break;
            }
          };

          vm.validateRequiredFields = function() {
            vm.showValidation = true;
            vm.fields.map(x => {
              if (x.definition.id === 'dfd0fd1c-8c4d-4e9e-be98-a79f26310960') {
                if (x.value === null) {
                  x.inValid = true;
                } else {
                  x.inValid = false;
                }
              }
            });
          };

          // todo: remove these hardcoded id's somehow
          vm.filterFields = function(field) {
            if (field.definition.id === '04c56e09-eeff-4982-a243-0688b6f45a74') return false; //Country
            if (field.definition.id === '8e18c532-ed32-49b5-bd7b-1c5529c38d15') return false; //Crm type
            if (field.definition.id === 'ef5606cf-21ec-4de9-97f2-71a9d8192748') return false; //Relation type
            if (field.definition.id === 'e31bb7ad-afb4-4a37-bd1e-46d4a9a71cf0') return false; //Own Company

            return true;
          };

          var save = function(fields) {
            vm.isLoading = true;
            relPersistSvc
              .save(fields)
              .then(function(data) {
                if (data) {
                  $q.when(
                    vm.success({
                      relation: data,
                      isNew: true,
                    }),
                  ).then(function() {
                    vm.isLoading = false;
                  });
                }
              }) //no showError needed, relPersistSvc already handles error
              .finally(() => {
                vm.isLoading = false;
              });
          };
          var getFieldValue = function(defId) {
            var fields = vm.fields.filter(function(el) {
              return el.definition && el.definition.id && el.definition.id === defId;
            });
            if (fields.length > 0 && typeof fields[0].value !== 'undefined') return fields[0].value;
            return null;
          };

          vm.submit = function() {
            vm.isLoading = true;

            var fieldsToSave = vm.fields;

            const teamsField = fieldsToSave.find(
              x => x.definition && x.definition.id === 'b5a73c11-4b57-436c-9236-2424594e16fe',
            );

            if (teamsField) {
              teamsField.value = vm.teams;
            }


            const tagsField = fieldsToSave.find(
              x => x.definition && x.definition.id === '6153cbcf-5347-4f8a-8a1d-dcea1cee2df6',
            );

            if (tagsField) {
              tagsField.value = vm.tags;
            }

            let name = null;
            let firstName = null;
            let vatNumber = null;
            let nationalNumber = null;
            let enterpriseNumber = null;
            let kvkNumber = null;
            let rsinNumber = null;
            let bsnNumber = null;
            vatNumber = getFieldValue('dfd0fd1c-8c4d-4e9e-be98-a79f26310960') || null;
            if (vatNumber === 'VatPending') vatNumber = null;
            if (vm.relType === 0) {
              name = getFieldValue('ccb058e7-f972-4215-82f1-0efdd16deb7d') || null;
            } else {
              name = getFieldValue('fa994e2f-20ce-427d-a300-29bb197ae197') || null;
              firstName = getFieldValue('3ae9604f-fbbd-4eaa-ad0d-954cbcbcf21d') || null;
            }
            nationalNumber = getFieldValue('3b8e7746-100e-4e5c-930b-4de7628a574b') || null;
            enterpriseNumber = getFieldValue('11cbb373-2ad8-496f-872f-f4a4be31b9a5') || null;
            kvkNumber = getFieldValue('c7cc236a-1c66-4d35-88d9-ca8bb27872f2') || null;
            rsinNumber = getFieldValue('f59eefa9-4197-4978-b976-17cab69d05ae') || null;
            bsnNumber = getFieldValue('082502ef-031b-4c37-9cf4-95dd4fb59905') || null;

            return getSimilarRelations(
              name,
              firstName,
              vatNumber,
              nationalNumber,
              enterpriseNumber,
              kvkNumber,
              rsinNumber,
              bsnNumber,
            ).then(function(similarRelations) {
              if (similarRelations.length) {
                return dialogsSvc.showSimilarRelations(similarRelations).then(
                  function(result) {
                    if (result) {
                      $q.when(
                        vm.success({
                          relation: result,
                          isNew: false,
                        }),
                      ).then(function() {
                        vm.isLoading = false;
                      });
                    } else if (result === null) {
                      vm.isLoading = false; //Cancel
                    } else {
                      save(fieldsToSave); //Continue
                    }
                  },
                  function() {
                    vm.isLoading = false;
                  },
                );
              } else {
                save(fieldsToSave);
              }
            });
          };

          var getSimilarRelations = (
            name = null,
            firstName = null,
            vatNumber = null,
            nationalNumber = null,
            enterpriseNumber = null,
            kvkNumber = null,
            rsinNumber = null,
            bsnNumber = null,
          ) => {
            var params = new URLSearchParams();

            if (name !== null) params.append('name', name);
            if (firstName !== null) params.append('firstName', firstName);
            if (vatNumber !== null) params.append('vatNumber', vatNumber);
            if (nationalNumber !== null) params.append('nationalNumber', nationalNumber);
            if (enterpriseNumber !== null) params.append('enterpriseNumber', enterpriseNumber);
            if (kvkNumber !== null) params.append('kvkNumber', kvkNumber);
            if (rsinNumber !== null) params.append('rsinNumber', rsinNumber);
            if (bsnNumber !== null) params.append('bsnNumber', bsnNumber);

            return $http
              .get(`${appUrls.api}/api/relation/Similar?${params.toString()}`)
              .then(({ data }) => {
                return data;
              });
          };

          vm.externalRelationSearchResult = null;
          vm.externalRelationSearchTerm = null;

          vm.searchExternalRelation = function(val) {
            vm.externalRelationSearchResult = null;
            vm.searching = true;
            return externalRelationHttpSvc
              .search(val, 25, vm.searchProvider, vm.company.id)
              .then(function(data) {
                vm.externalRelationSearchTerm = val;
                vm.searching = false;
                if (data.length === 25)
                  data.push({
                    id: -1,
                    officialName: '- ' + $filter('translate')('Show all'),
                    number: '',
                  });
                return data;
              }, showError);
          };

          vm.searchProviderChanged = () => {
            vm.externalRelationSearchResult = null;
            vm.externalRelationSearchTerm = null;
            vm.externalRelationSearch = null;
            setSearchCriteriaString();
          };

          vm.openExternalRelationSearchDialog = function() {
            dialogsSvc
              .showExternalRelationSearchDialog(vm.externalRelationSearchTerm, vm.searchProvider)
              .then(function(result) {
                vm.externalRelationSearchTerm = null;
                vm.externalRelationSearchResult = null;

                if (result) {
                  let uniqueIdentifier = '';
                  switch (vm.searchProvider) {
                    case 0:
                      uniqueIdentifier = result.id;
                      break;
                    case 1:
                      uniqueIdentifier = result.kvkNumber;
                      break;
                    case 3:
                      uniqueIdentifier = result.number;
                      break;
                  }
                  if (uniqueIdentifier) {
                    externalRelationHttpSvc
                      .details(uniqueIdentifier, vm.searchProvider)
                      .then(function(data) {
                        vm.externalRelationSearchResult = data;
                        vm.externalRelationSearchResult.crmType =
                          vm.options.crmType !== null ? vm.options.crmType : 3;
                        // vm.collapsed = -1;
                      }, showError);
                  }
                }
              });
          };

          vm.selectionChanged = function(item) {
            // "show all" was selected
            if (item.id === -1) {
              vm.openExternalRelationSearchDialog();
            } else {
              vm.externalRelationSearchResult = {
                ...item,
                crmType: vm.options.crmType !== null ? vm.options.crmType : 3,
              };
              // the initial search result for certain external relation sources like KBO only contains minimal data.
              // we will do a detail call to retrieve and display additional info.
              const retrieveDetailsRelationSourceTypes = [2, 15, 17, 25, 26];
              if (
                retrieveDetailsRelationSourceTypes.includes(
                  vm.externalRelationSearchResult.sourceType,
                )
              ) {
                let uniqueIdentifier = '';
                switch (vm.externalRelationSearchResult.sourceType) {
                  case 2:
                    uniqueIdentifier = vm.externalRelationSearchResult.id;
                    break;
                  case 15:
                  case 25:
                    uniqueIdentifier = vm.externalRelationSearchResult.kvkNumber;
                    break;
                  case 17:
                  case 26:
                    uniqueIdentifier = vm.externalRelationSearchResult.number;
                    break;
                }
                externalRelationHttpSvc
                  .details(uniqueIdentifier, vm.searchProvider)
                  .then(function(data) {
                    vm.externalRelationSearchResult = {
                      ...vm.externalRelationSearchResult,
                      ...data,
                    };
                  }, showError);
              }
            }
          };

          vm.externalRelationSearchInputKeyUp = function(event, term) {
            if (event.keyCode === 27) {
              vm.externalRelationSearchTerm = null;
              vm.externalRelationSearchResult = null;
            }
            if (event.keyCode === 13 && term && term.length < 4) {
              vm.externalRelationSearchTerm = term;
              vm.openExternalRelationSearchDialog();
            }
          };

          vm.addRelation = function() {
            vm.isLoading = true;
            if (!vm.externalRelationSearchResult) return;

            const model = {
              ...vm.externalRelationSearchResult,
              searchProvider: vm.searchProvider,
              companyId: vm.company.id,
              teams: vm.teams.map(x => x.id),
              tags: vm.tags
            };

            var doCreateRelation = () =>
              externalRelationHttpSvc.create(model).then(
                function(response) {
                  vm.success({
                    relation: response,
                    isNew: true,
                  });
                  vm.isLoading = false;
                },
                function(error) {
                  flySvc.error(error);
                  vm.isLoading = false;
                },
              );

            return getSimilarRelations(
              null,
              null,
              null,
              null,
              model.number,
              model.kvkNumber,
              model.rsinNumber,
              model.bsnNumber,
            ).then(function(similarRelations) {
              if (similarRelations.length) {
                return dialogsSvc.showSimilarRelations(similarRelations).then(
                  function(result) {
                    if (result) {
                      $q.when(
                        vm.success({
                          relation: result,
                          isNew: false,
                        }),
                      ).then(function() {
                        vm.isLoading = false;
                      });
                    } else if (result === null) {
                      vm.isLoading = false; //Cancel
                    } else {
                      return doCreateRelation(); //Continue
                    }
                  },
                  function() {
                    vm.isLoading = false;
                  },
                );
              } else {
                return doCreateRelation();
              }
            });
          };

          vm.focusFirstField = function() {
            $timeout(function() {
              $element
                .find(
                  '.form-horizontal .fields .form-group input, .form-horizontal .fields .form-group textarea, .form-horizontal .fields .form-group select',
                )
                .filter(':visible')
                .first()
                .focus();
            }, 200);
          };

          if (vm.relType !== null && vm.crmType !== null && vm.country) vm.create();
        },
      ],
    };
  },
]);
